import React, { Component } from 'react';
import { connect } from 'react-redux';
import WorkAreaView from './WorkArea.view';
import { notifyNewTrades } from './Trades/Trades.helper';

export class WorkAreaContainer extends Component {
  constructor(props){
    super(props);
    this.logout = this.logout.bind(this);
  }
  logout(){
    const { dispatch, history } = this.props;
    dispatch({
      $global: true,
      type: 'LOGOUT',
      meta: {
        history: history,
      }
    });
  }
  componentDidMount(){
    const { dispatch } = this.props;

    dispatch({
      type: 'FETCH_DYNAMIC_DATA',
    });

    this.intervalId = setInterval(notifyNewTrades, 10 * 1000);
  }
  componentWillUnmount(){
    clearInterval(this.intervalId);
  }
  render() {
    return (<WorkAreaView
      {...this.props}
      logout={this.logout}
    />);
  }

}

function mapStateToProps(state) {
  return {
    rateLimitRemaining: state.app.rateLimitRemaining,
  };
}

export default connect(mapStateToProps)(WorkAreaContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/WorkArea.container.js